import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';
import { initPostHog } from './core/analytics/posthog';

// Initialize PostHog early — before React renders, so first pageview is captured.
// Safe to call: no-ops if env vars are missing.
initPostHog();

// ── E2E Test Hooks (non-production only) ──
// Expose internal singletons on window for Playwright quality-verification tests.
// Tree-shaken in production builds by Vite (import.meta.env.PROD).
if (!import.meta.env.PROD) {
  import('./core/supabase/client').then(({ supabase }) => {
    (globalThis as Record<string, unknown>).__supabase = supabase;
  });
  import('./core/context/engine').then(({ contextEngine }) => {
    (globalThis as Record<string, unknown>).__contextEngine = contextEngine;
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
